import clsx from 'clsx'; // Install with `npm install clsx`
import { Button } from '../ui/button'; // Ensure the button component is properly set up
import { Add24Regular } from '@fluentui/react-icons'; // Import the Fluent UI icon
import SpinnerIcon from '../icon/Spinner';
import { useTranslation } from 'react-i18next';

interface Iprops {
  description: JSX.Element | string | null;
  className?: string;
  logo?: string; // URL de l'image (optionnel)
  buttonText?: string; // Button text (optional)
  onButtonClick?: () => void; // Button click handler (optional)
  isLoading?: boolean;
  canCreate?: boolean;
  buttonIcon?: JSX.Element;
  customComponent?: JSX.Element; // New prop for custom JSX component
  disabled?: boolean; // Greys out the action button when true
  disabledTitle?: string; // Tooltip shown when disabled
}

export const RightPanelPlaceHolder = ({
  description,
  className,
  logo,
  buttonText,
  isLoading,
  onButtonClick,
  canCreate = true,
  buttonIcon = <Add24Regular fontSize={24} className="text-2xl" />,
  customComponent,
  disabled = false,
  disabledTitle,
}: Iprops): JSX.Element => {
  const { t } = useTranslation();

  return (
    <div
      className={clsx(
        'flex flex-col h-full justify-center items-center gap-6 w-full',
      )}
      role="region"
      aria-label="Right Panel Placeholder"
    >
      {/* Custom Component Section */}


      {/* Logo Section */}
      {logo ? (
        <img
          src={logo}
          alt="Right Panel Placeholder Logo"
          className="object-contain mb-4"
        />
      ) : (
        <div className="w-24 h-24 mb-4 bg-gray-200 rounded-md" />
      )}

      {/* Description Section */}
      {description ? (
        <div className="mt-5">
          <h5 className="text-base font-normal text-center text-neutral-20">
            {description}
          </h5>
        </div>
      ) : (
        <p className="text-center text-gray-400">No description provided</p>
      )}

      {/* Button Section */}
      {onButtonClick && canCreate && (
        <span title={disabled ? disabledTitle : undefined}>
          <Button
            type="button"
            onClick={onButtonClick}
            disabled={isLoading || disabled}
          >
            {isLoading ? <SpinnerIcon /> : buttonIcon}

            {buttonText || t('common.new')}
          </Button>
        </span>
      )}
      {customComponent && (
        <div className="w-full">
          {customComponent}
        </div>
      )}
    </div>
  );
};

// Default Props
RightPanelPlaceHolder.defaultProps = {
  className: '',
  logo: '',
  buttonText: '',
  onButtonClick: undefined,
};

export default RightPanelPlaceHolder;
